import { createSlice } from '@reduxjs/toolkit';
import webServices from '../../services/webServices';

const initialState = {
  isLoading: false,
  isSaving: false,
  isDeleteLoading: false,
  error: false,
  success: '',
  coverageList: []
};

const slice = createSlice({
  name: 'homeCoverage',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    startSaving(state) {
      state.isSaving = true;
      state.success = '';
    },
    startDeleteLoading(state) {
      state.isDeleteLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.isSaving = false;
      state.isDeleteLoading = false;
      state.error = action.payload;
    },
    getCoverageListSuccess(state, action) {
      state.isLoading = false;
      state.coverageList = action.payload;
    },
    saveCoverageSuccess(state, action) {
      state.isSaving = false;
      state.success = action.payload;
    },
    deleteCoverageSuccess(state, action) {
      state.isDeleteLoading = false;
      state.success = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  hasError,
  startLoading,
  startSaving,
  startDeleteLoading,
  getCoverageListSuccess,
  saveCoverageSuccess,
  deleteCoverageSuccess
} = slice.actions;

// ----------------------------------------------------------------------

export function getHomeCoverage() {
  return async (dispatch) => {
    dispatch(startLoading());
    try {
      const resp = await webServices.getHomeCoverage();
      if (resp && resp.success === true) {
        dispatch(getCoverageListSuccess(resp.data));
      } else {
        dispatch(hasError(resp?.message));
      }
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}

export function createHomeCoverage(data) {
  return async (dispatch) => {
    dispatch(startSaving());
    try {
      const resp = await webServices.createHomeCoverage(data);
      if (resp && resp.success === true) {
        dispatch(saveCoverageSuccess('Saved successfully'));
        dispatch(getHomeCoverage());
      } else {
        dispatch(hasError(resp?.message));
      }
      return resp;
    } catch (error) {
      dispatch(hasError(error));
      return { success: false };
    }
  };
}

export function updateHomeCoverage(id, data) {
  return async (dispatch) => {
    dispatch(startSaving());
    try {
      const resp = await webServices.updateHomeCoverage(id, data);
      if (resp && resp.success === true) {
        dispatch(saveCoverageSuccess('Updated successfully'));
        dispatch(getHomeCoverage());
      } else {
        dispatch(hasError(resp?.message));
      }
      return resp;
    } catch (error) {
      dispatch(hasError(error));
      return { success: false };
    }
  };
}

export function deleteHomeCoverage(id) {
  return async (dispatch) => {
    dispatch(startDeleteLoading());
    try {
      const resp = await webServices.deleteHomeCoverage(id, {});
      if (resp && resp.success === true) {
        dispatch(deleteCoverageSuccess('Deleted successfully'));
        dispatch(getHomeCoverage());
      } else {
        dispatch(hasError(resp?.message));
      }
      return resp;
    } catch (error) {
      dispatch(hasError(error));
      return { success: false };
    }
  };
}
